export const LINK_WHATSAPP = 'https://api.whatsapp.com/send?phone=554430237230&text=Olá!! Tenho interesse na agenda para Clubes e Associações';
